import { ChevronRightIcon } from '@heroicons/react/24/outline';
import Link from 'components/gruenland/atoms/link';
import Typography from 'components/gruenland/atoms/typography';
import toAccountUrl from 'helpers/account/toAccountUrl';
import { useFormat } from 'helpers/hooks/useFormat';
import InfoCard, { InfoField } from '../../../account-atoms/info-card';

const Integrity = () => {
  const { formatMessage } = useFormat({ name: 'gruenland' });

  // Integrity fields
  const integrityButtons: Array<InfoField> = [
    {
      label: formatMessage({ id: 'account.passwordChange', defaultMessage: 'Cambia password' }),
      value: '?hash=profile&id=change-password',
    },
    {
      label: formatMessage({ id: 'account.delete', defaultMessage: 'Elimina account' }),
      value: '?hash=profile&id=delete-account',
    },
  ].map(({ value, ...rest }) => ({
    value: toAccountUrl(value),
    ...rest,
  }));

  return (
    <InfoCard
      title={formatMessage({ id: 'account.integrity', defaultMessage: 'Integrità account' })}
      clearPadding
      cardClassName="grid"
    >
      {integrityButtons.map(({ label, value }, index) => (
        <Link key={index} link={value} className="hover:cursor-pointer">
          <div className="flex items-center justify-between pr-8 md:pr-9">
            <Typography className="py-6 pl-4 pr-8 text-[14px] font-medium text-primary-black md:pl-6">
              {label}
            </Typography>

            <ChevronRightIcon className="h-6 w-5 text-secondary-black" />
          </div>

          {index === 0 && <hr />}
        </Link>
      ))}
    </InfoCard>
  );
};

export default Integrity;
